import React from 'react';
import { AreaForm } from '../../models/area.model';
import TagInput from '../common/TagInput';
import Checkbox from '../common/Checkbox';
import './index.css'
import { DiscordIcon } from '../common/Icons';

interface NotificationsProps {
  action: string;
  handleSelection?: (key: string, value: any) => void;
  areaForm: AreaForm;
}

const Notifications: React.FC<NotificationsProps> = ({
  action,
  handleSelection,
  areaForm,
}) => {

  const handleCheckNotifAction = (index: number, action: string, value: boolean) => {
    const notifActions = areaForm.notifs.map((notif, i) => i === index ? { ...notif, [action]: value ? 'true' : 'false' } : notif)
    handleSelection && handleSelection('notifs', notifActions)
  }


  return (
    <React.Fragment>
      <div className='area-form-section'>
        <div className='area-form-section-title'>
          <p>Notificaciones</p>
        </div>

        <div className='area-form-section-item__notif'>
          <TagInput
            label='Emails'
            name='emails'
            placeholder='example@mail.com'
            values={areaForm.emails}
            handleSelection={handleSelection}
            disabled={action === 'view'}
          />

        </div>

        <div className='area-form-section-item__notif'>
          <TagInput
            label='Discord'
            name='discords'
            placeholder='https://discord.com/api/webhooks/...'
            values={areaForm.discords}
            handleSelection={handleSelection}
            disabled={action === 'view'}
          />

        </div>

        {(areaForm.notifs.length > 0) && (
          <div className='area-form-section-item__notif'>
            <div className='item-notifaction-table'>
              <div className='item-notifaction-row'>

                <div className='item-notifaction-labelspace' />
                <label className='item-notifaction-labelcol item-notifaction-entry'>Creación</label>
                <label className='item-notifaction-labelcol item-notifaction-entry'>Actualización</label>
                <label className='item-notifaction-labelcol item-notifaction-entry'>Cierre</label>

              </div>
              {
                areaForm.notifs.map((item, index) => (
                  <div key={index} className='item-notifaction-row'>
                    <div className='item-notifaction-labelspace'>
                      <label className='item-notifaction-labelrow'>{item.type}</label>
                    </div>
                    <div className='item-notifaction-box-selection item-notifaction-entry'>
                      <Checkbox
                        name='enabled'
                        value={item.tkt_create === 'true'}
                        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCheckNotifAction(index, 'tkt_create', event.target.checked)}
                        disabled={action === 'view'}
                      />
                    </div>
                    <div className='item-notifaction-box-selection item-notifaction-entry'>
                      <Checkbox
                        name='enabled'
                        value={item.tkt_update === 'true'}
                        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCheckNotifAction(index, 'tkt_update', event.target.checked)}
                        disabled={action === 'view'}
                      />
                    </div>
                    <div className='item-notifaction-box-selection item-notifaction-entry'>
                      <Checkbox
                        name='enabled'
                        value={item.tkt_close === 'true'}
                        handleChange={(event: React.ChangeEvent<HTMLInputElement>) => handleCheckNotifAction(index, 'tkt_close', event.target.checked)}
                        disabled={action === 'view'}
                      />
                    </div>
                  </div>
                ))
              }
            </div>

          </div>
        )}

      </div>

    </React.Fragment>
  );
}

export default Notifications;